import { render, staticRenderFns } from "./IntegrationHooks.vue?vue&type=template&id=bca035bc&scoped=true&"
import script from "./IntegrationHooks.vue?vue&type=script&lang=js&"
export * from "./IntegrationHooks.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationHooks.vue?vue&type=style&index=0&id=bca035bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bca035bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bca035bc')) {
      api.createRecord('bca035bc', component.options)
    } else {
      api.reload('bca035bc', component.options)
    }
    module.hot.accept("./IntegrationHooks.vue?vue&type=template&id=bca035bc&scoped=true&", function () {
      api.rerender('bca035bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/settings/integrationapps/IntegrationHooks.vue"
export default component.exports